import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomSecondaryAirInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomSecondaryAirInput = React.memo(
  ({ hideLabel, autoFocus }: RoomSecondaryAirInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.sec"
        className="room-form__secondary-air"
        label={t("Room.sec")}
        unit="m³/h"
        color="#f49f33"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__secondary-air__input"
      />
    )
  }
)
